import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from '../queries/queryKeys';

const changeAttributes = async ({ houseId, ...value }) => {
  return await request.put(
    '/HousingStock/address/attributes',
    value,
    'При изменении атрибутов помещения произошла ошибка',
    'Error'
  );
};

const useChangeAttributes = () => {
  const queryClient = useQueryClient();

  return useMutation(changeAttributes, {
    onSuccess: (data, { houseId }) => {
      if (data === 'Error') return;

      queryClient.refetchQueries(getQueryKeys.flatsGrid(houseId));
    },
  });
};

export default useChangeAttributes;
